var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _linearGradient62, _linearGradient63, _linearGradient64, _linearGradient65, _linearGradient66, _linearGradient67, _linearGradient68, _linearGradient69, _linearGradient70;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderautomation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 491.6223 455.8437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e9ee71f5-3e9b-4d1d-89f9-189541c3b282",
    x1: 304.949,
    y1: 343.295,
    x2: 338.4774,
    y2: 343.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3787,
    stopColor: "#57d9a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36b37e"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a74f7ef6-10e4-4a07-be54-91bdc2d16c79",
    x1: 6.8761,
    y1: 340.4501,
    x2: 499.8542,
    y2: 340.4501,
    gradientTransform: "matrix(0.9565, -0.0796, 0.2199, 0.3464, -64.3626, 311.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#deebff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#deebff",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#deebff",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#deebff",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#deebff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#deebff",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deebff",
    stopOpacity: 0.3
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd9b1cad-b29a-47b1-9f3b-5951ad1c63c6",
    x1: 30.0442,
    y1: 368.4913,
    x2: 470.5198,
    y2: 368.4913,
    gradientTransform: "matrix(0.8395, -0.3038, 0.3254, 0.3892, -35.0357, 334.5502)",
    xlinkHref: "#a74f7ef6-10e4-4a07-be54-91bdc2d16c79"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e2acbb4c-62aa-4a20-b115-7157519550d4",
    x1: 318.7794,
    y1: 386.5,
    x2: 338.9852,
    y2: 386.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a74f7ef6-10e4-4a07-be54-91bdc2d16c79"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b9d0df59-2382-4608-94ef-aeecf27e1672",
    x1: 315.5742,
    y1: 386.5,
    x2: 342.1904,
    y2: 386.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2d4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deebff"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab719951-9853-429f-a7d7-fc81afc8eb35",
    x1: 394.97,
    y1: 358.4559,
    x2: 415.1759,
    y2: 358.4559,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a74f7ef6-10e4-4a07-be54-91bdc2d16c79"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b9153f8c-92a2-4608-925b-efcce3355203",
    x1: 391.7649,
    y1: 358.4559,
    x2: 418.381,
    y2: 358.4559,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a74f7ef6-10e4-4a07-be54-91bdc2d16c79"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b74041a5-982f-46b0-900c-8a516855f334",
    x1: 446.5699,
    y1: 287.2301,
    x2: 455.9036,
    y2: 287.2301,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a74f7ef6-10e4-4a07-be54-91bdc2d16c79"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eabe4242-d200-46fb-80a8-aefcaaa132cf",
    x1: 119.0127,
    y1: 363.4734,
    x2: 146.4021,
    y2: 363.4734,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a74f7ef6-10e4-4a07-be54-91bdc2d16c79"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf5e3b3c-138a-4027-923a-32d16f885990",
    x1: 99.1927,
    y1: 168.2963,
    x2: 139.7854,
    y2: 168.2963,
    gradientTransform: "translate(33.3836 -19.286) rotate(10.718)",
    xlinkHref: "#a74f7ef6-10e4-4a07-be54-91bdc2d16c79"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f388994d-1a36-44fb-8e06-992c32865d1e",
    x1: -307.7362,
    y1: 383.6108,
    x2: -307.7362,
    y2: 476.4765,
    gradientTransform: "translate(66.4449 502) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfe9f9",
    stopOpacity: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5c2ed",
    stopOpacity: 0.646
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#72a0e3",
    stopOpacity: 0.449
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4984db",
    stopOpacity: 0.288
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#296ed4",
    stopOpacity: 0.162
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#125fd0",
    stopOpacity: 0.072
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#0555cd",
    stopOpacity: 0.018
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#0052cc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#0052cc",
    stopOpacity: 0.022
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#0052cc",
    stopOpacity: 0.087
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#0052cc",
    stopOpacity: 0.195
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#0052cc",
    stopOpacity: 0.345
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#0052cc",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#0052cc",
    stopOpacity: 0.774
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0052cc"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac0a5b51-b499-48bb-8f26-0633f3a8ef0c",
    x1: 69.564,
    y1: 178.7658,
    x2: 86.0325,
    y2: 178.7658,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a74f7ef6-10e4-4a07-be54-91bdc2d16c79"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ecb51dc8-1b7c-42cd-9a0b-725fab3dc606",
    x1: 241.7592,
    y1: 207.5841,
    x2: 292.8848,
    y2: 243.2754,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f0ccc704-3c26-4e71-896c-a71eba81660d",
    x1: 131.0439,
    y1: 203.8137,
    x2: 179.2749,
    y2: 242.3983,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e2abe583-c0e8-4ea9-a588-3965eb413921",
    x1: 190.6791,
    y1: 308.3626,
    x2: 242.0396,
    y2: 340.7926,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a93442bd-7961-4639-857c-6f46d7397220",
    x1: 158.1445,
    y1: 4.1676,
    x2: 158.4642,
    y2: 42.2165,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#f388994d-1a36-44fb-8e06-992c32865d1e"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ada61ae2-39c3-492a-b941-38ae66e9cd69",
    x1: 182.9998,
    y1: 110.3103,
    x2: 237.9834,
    y2: 145.0368,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a48ad440-f914-4f50-b74a-d14000a0f16b",
    x1: 243.4019,
    y1: 203.6575,
    x2: 243.4019,
    y2: 139.801,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a175eabd-af2c-4f42-b63f-b41a05dd5c0d",
    x1: 270.9019,
    y1: 177.3681,
    x2: 326.9019,
    y2: 177.3681,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e228332c-5aae-42f1-b5b8-4b610ba3850a",
    x1: 355.4019,
    y1: 206.642,
    x2: 355.4019,
    y2: 145.1954,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f56c34cd-bbb8-4088-95f5-56f5e3e8357a",
    x1: 186.9022,
    y1: 114.8735,
    x2: 186.9022,
    y2: 47.8926,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a1f1f08e-f1ae-4bf6-9296-746a924e81bb",
    x1: 298.4019,
    y1: 301.2863,
    x2: 298.4019,
    y2: 239.2212,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ef090978-968e-4eed-98bd-a2e89da5f47b",
    x1: 186.4019,
    y1: 300.4771,
    x2: 186.4019,
    y2: 234.9331,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a5a773f5-a4c5-4440-ae1e-9579d9b822ac",
    x1: 242.4019,
    y1: 399.0651,
    x2: 242.4019,
    y2: 337.1529,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f900595a-19b2-46eb-9b4a-75f66ae96441",
    x1: 353.7054,
    y1: 208.287,
    x2: 407.7245,
    y2: 239.1551,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb182fbe-893b-4da1-80e3-bc71b234ff5a",
    x1: 411.9019,
    y1: 303.4586,
    x2: 411.9019,
    y2: 242.3325,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd26f76f-8f02-49c8-9e0b-40184450780f",
    x1: 327.6139,
    y1: 101.1676,
    x2: 327.9337,
    y2: 139.2165,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#f388994d-1a36-44fb-8e06-992c32865d1e"
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a326a6fb-1a68-4a14-92a7-9afca34aa07c",
    x1: 299.7592,
    y1: 367.9379,
    x2: 350.8848,
    y2: 403.6292,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fd6c61e2-4329-4d64-adfc-a5cc75adc0b8",
    x1: 315.9019,
    y1: 298,
    x2: 315.9019,
    y2: 233,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a74f7ef6-10e4-4a07-be54-91bdc2d16c79"
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b7b2cfc8-fb44-4be0-ab3b-178685d9787b",
    x1: 105.9923,
    y1: 274.9239,
    x2: 153.6639,
    y2: 274.9239,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb0b558d-307d-4919-b643-fefac43ce753",
    x1: 106.0522,
    y1: 293.7612,
    x2: 153.604,
    y2: 293.7612,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ecacab6c-af32-4305-90c8-4ef52b4a7ab7",
    x1: 106.0522,
    y1: 289.0519,
    x2: 153.604,
    y2: 289.0519,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a61d771a-b867-4413-9015-8dd22e0a8785",
    x1: 106.0522,
    y1: 284.3426,
    x2: 153.604,
    y2: 284.3426,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e46a541b-a525-41b4-a268-f00a9b452648",
    x1: 106.0522,
    y1: 279.6332,
    x2: 153.604,
    y2: 279.6332,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b63dba73-f2c5-4b90-8c0a-b926e9de9e6a",
    x1: 106.0522,
    y1: 274.9239,
    x2: 153.604,
    y2: 274.9239,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b8febaa3-6627-45b0-84f2-88bac111e981",
    x1: 106.0522,
    y1: 270.2146,
    x2: 153.604,
    y2: 270.2146,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f39a9be9-f2fb-4290-9ca3-b0b394fb62f6",
    x1: 106.0522,
    y1: 265.5052,
    x2: 153.604,
    y2: 265.5052,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac7bf252-f896-4970-a3b2-194cb8079e58",
    x1: 106.0522,
    y1: 260.7959,
    x2: 153.604,
    y2: 260.7959,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a0c8097c-a387-4580-a1d1-6509f525738c",
    x1: 106.0522,
    y1: 256.0866,
    x2: 153.604,
    y2: 256.0866,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb45b82e-d37c-461c-a0de-ce99fd6e5cda",
    x1: 147.4862,
    y1: 285.7652,
    x2: 147.7362,
    y2: 285.7652,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a9f645ea-db9b-47aa-a7fd-3f9c9f1a5673",
    x1: 141.5585,
    y1: 282.1514,
    x2: 141.8085,
    y2: 282.1514,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf76642f-8da9-45c0-a172-a3e96a3c810d",
    x1: 135.6308,
    y1: 278.5377,
    x2: 135.8808,
    y2: 278.5377,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b0cf2261-d01b-4a5c-b971-4d98fb612cc2",
    x1: 129.7031,
    y1: 274.9239,
    x2: 129.9531,
    y2: 274.9239,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "acce527f-4e9f-4b95-974e-af6e0eb7206b",
    x1: 123.7754,
    y1: 271.3101,
    x2: 124.0254,
    y2: 271.3101,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a9c6d260-e6fa-404b-9a74-3e52d2ae07cf",
    x1: 117.8477,
    y1: 267.6964,
    x2: 118.0977,
    y2: 267.6964,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "efc78f4e-74fa-4d19-9f8f-78f8237a6a52",
    x1: 111.92,
    y1: 264.0826,
    x2: 112.17,
    y2: 264.0826,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a5e2f2f9-5feb-4d66-8d7d-72b51192b681",
    x1: 132.9262,
    y1: 333.1933,
    x2: 132.9262,
    y2: 284.3448,
    gradientTransform: "matrix(1, 0.3135, 0, 1, -3.0981, -69.3789)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0065ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c9aff"
  }))), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fa2ee24f-494f-4ad9-a2d4-a86290546a62",
    x1: 319.9019,
    y1: 296,
    x2: 319.9019,
    y2: 231,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a74f7ef6-10e4-4a07-be54-91bdc2d16c79"
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b69614c1-9c6d-4904-b0ca-143e7340581c",
    x1: 390.1821,
    y1: 302.1625,
    x2: 407.4211,
    y2: 302.1625,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f9db450b-ace9-40af-bc09-24f07c7d6c51",
    x1: 415.2166,
    y1: 261.9247,
    x2: 432.4559,
    y2: 261.9247,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b4858666-5609-449f-9795-0c78f1d5fa9d",
    x1: 415.2164,
    y1: 255.8219,
    x2: 432.4555,
    y2: 255.8219,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a286c831-031e-417f-8814-aa02985ef1fd",
    x1: 415.2166,
    y1: 249.7197,
    x2: 432.4559,
    y2: 249.7197,
    xlinkHref: "#b9d0df59-2382-4608-94ef-aeecf27e1672"
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f1453355-f8ec-4c26-8ef5-84d7086e5285",
    x1: 221,
    y1: 278.9434,
    x2: 273,
    y2: 278.9434,
    gradientTransform: "matrix(1, 0.5774, 0, 1, -3.0981, -159.0489)",
    xlinkHref: "#a5e2f2f9-5feb-4d66-8d7d-72b51192b681"
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f5194b6d-a3b3-4863-9025-0d58246ebab3",
    x1: 221,
    y1: 295.4799,
    x2: 273,
    y2: 295.4799,
    gradientTransform: "matrix(1, 0.5774, 0, 1, -3.0981, -159.0489)",
    xlinkHref: "#a5e2f2f9-5feb-4d66-8d7d-72b51192b681"
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b2918eac-06b4-441d-b2d1-051ba5529d7e",
    x1: 221,
    y1: 311.4799,
    x2: 273,
    y2: 311.4799,
    gradientTransform: "matrix(1, 0.5774, 0, 1, -3.0981, -159.0489)",
    xlinkHref: "#a5e2f2f9-5feb-4d66-8d7d-72b51192b681"
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a4a69084-eee4-49ae-ac3b-7bf90a66265d",
    x1: 273,
    y1: 249.0243,
    x2: 329,
    y2: 249.0243,
    gradientTransform: "matrix(1, -0.5774, 0, 1, -3.0981, 185.6292)",
    xlinkHref: "#a5e2f2f9-5feb-4d66-8d7d-72b51192b681"
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e910bbba-3cd4-4a9b-af69-0cc03f4f1f95",
    x1: 273,
    y1: 265.3051,
    x2: 329,
    y2: 265.3051,
    gradientTransform: "matrix(1, -0.5774, 0, 1, -3.0981, 185.6292)",
    xlinkHref: "#a5e2f2f9-5feb-4d66-8d7d-72b51192b681"
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf789a93-aea7-4d90-96e6-85e583f837c9",
    x1: 273,
    y1: 282.3051,
    x2: 329,
    y2: 282.3051,
    gradientTransform: "matrix(1, -0.5774, 0, 1, -3.0981, 185.6292)",
    xlinkHref: "#a5e2f2f9-5feb-4d66-8d7d-72b51192b681"
  })), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a835363d-79f8-4779-8e9b-32a33f27db6f",
    x1: 118.9921,
    y1: 93.9679,
    x2: 144,
    y2: 93.9679,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a5e2f2f9-5feb-4d66-8d7d-72b51192b681"
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b9d398f8-765c-46db-8f22-8b0cfccde61d",
    x1: 126.1257,
    y1: 94.4974,
    x2: 137.6472,
    y2: 94.4974,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a5e2f2f9-5feb-4d66-8d7d-72b51192b681"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a1ab52db-fab9-4584-afc8-5163a30189b7",
    transform: "translate(-3.0981 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.059,348.3517c-8.6772-14.423,2.8251-14.9381,0-23.0081-2.834-8.0951-10.09-7.04-8.879-14.2512C337.7168,301.9389,334.162,299,329.3189,299s-10.593,4.81-8.0718,13.1226c1.6144,5.3227-1.009,6.6963-4.6413,11.1606s-2.6233,10.9889,0,14.2513c3.388,4.2132,2.8626,6.823-.6054,10.9889-3.43,4.1208-4.0359,12.706,2.4216,15.4532s.6707,13.7568,4.6413,18.8872c5.4484,7.04,13.1167,7.04,15.9418-5.6662,1.8924-8.511-1.009-8.7568,2.6233-13.221S349.5824,355.8705,345.059,348.3517Zm-25.4262-12.5343c-3.9092-2.0492,2.8521-8.4718,3.9882-8.6653,0,0,3.386-2.1854,6.2269-.1553s-.8854,5.279-3.6806,6.4589S323.5418,337.8667,319.6328,335.8174Zm12.9149-25.7553c-1.8162,0-1.2108,3.2624-3.8342,2.5756s-.7251-6.1612,1.4126-6.01C332.5477,306.8,334.3638,310.0621,332.5477,310.0621Zm2.1543,43.051c-1.652-3.01,2.0873-6.2966,5.5044-4.6889a3.398,3.398,0,0,1,1.8256,1.9879c1.4126,3.9492,4.0359,6.1813.6054,6.5247C340.2265,357.1781,336.32,356.0626,334.702,353.1131Z",
    style: {
      fill: "url(#e9ee71f5-3e9b-4d1d-89f9-189541c3b282)"
    }
  })), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fd7fc85a-ea3c-4c40-bb7f-bb5de9729c14",
    x1: 324.6347,
    y1: 389.2837,
    x2: 324.6347,
    y2: 300.8266,
    xlinkHref: "#e9ee71f5-3e9b-4d1d-89f9-189541c3b282"
  })), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a4dd42f3-3dfb-4d3b-9ff6-dd92eba34b8b",
    x1: 183.3817,
    y1: 405.845,
    x2: 187.32,
    y2: 408.1096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a86c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5316,
    stopColor: "#a6aedb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d5ed"
  }))), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b65cdfa0-dd97-4aaa-9a5b-359a49f80d96",
    x1: 178.2408,
    y1: 407.2067,
    x2: 189.0027,
    y2: 407.2067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ededf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2198,
    stopColor: "#ebebf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2989,
    stopColor: "#e4e6f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3551,
    stopColor: "#d9dbf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3784,
    stopColor: "#d1d5ed"
  }))), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "af04084c-d0cd-4d89-ae2e-a6dfb2b3b5de",
    x1: 194.954,
    y1: 389.0235,
    x2: 198.8923,
    y2: 391.2881,
    xlinkHref: "#a4dd42f3-3dfb-4d3b-9ff6-dd92eba34b8b"
  })), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "abfb0c03-4093-4a0d-b49b-e344aad10071",
    x1: 189.8131,
    y1: 390.3853,
    x2: 200.5749,
    y2: 390.3853,
    xlinkHref: "#b65cdfa0-dd97-4aaa-9a5b-359a49f80d96"
  })), _linearGradient66 || (_linearGradient66 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab60d5c1-d54a-4080-a2b2-a0259ef65b1c",
    x1: 185.954,
    y1: 366.0235,
    x2: 189.8923,
    y2: 368.2881,
    xlinkHref: "#a4dd42f3-3dfb-4d3b-9ff6-dd92eba34b8b"
  })), _linearGradient67 || (_linearGradient67 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b43db1f6-daac-4c08-acd3-7c7d4398ff4c",
    x1: 180.8131,
    y1: 367.3853,
    x2: 191.5749,
    y2: 367.3853,
    xlinkHref: "#b65cdfa0-dd97-4aaa-9a5b-359a49f80d96"
  })), _linearGradient68 || (_linearGradient68 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "eafe3b0a-d083-458b-b307-e31b8fefb609",
    x1: 174.1352,
    y1: 394.1904,
    x2: 181.6301,
    y2: 394.1904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0065ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0049b0"
  }))), _linearGradient69 || (_linearGradient69 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a34a1c78-1159-42c9-bc27-b2f864b4fef7",
    x1: 187.3132,
    y1: 382.2804,
    x2: 191.6801,
    y2: 382.2804,
    xlinkHref: "#eafe3b0a-d083-458b-b307-e31b8fefb609"
  })), _linearGradient70 || (_linearGradient70 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bdc5e6fe-bee2-4e3e-9f97-1b22c37b9b56",
    x1: 173.7718,
    y1: 379.5729,
    x2: 191.2394,
    y2: 379.5729,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#a5e2f2f9-5feb-4d66-8d7d-72b51192b681"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "b3925d83-8fc1-4251-9d47-fc3abd483a52",
    "data-name": "BG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.72,403.8211c0,21.0186-18.5922,44.2226-127.0843,49.4094-88.2993,4.2215-132.0867-20.0082-175.3825-19.7469-33.86.2044-24.929,4.1368-71.4908,5.5682-56.5218,1.7376-97.07-7.4309-111.26-23.1544-20.0409-22.2059,9.46-42.1652,70.8189-46.5672,77.7144-5.5753,85.5637,2.51,120.7946,1.33,41.549-1.3921,35.7284-13.5407,128.0986-17.678C441.9281,347.9335,494.72,382.2382,494.72,403.8211Z",
    transform: "translate(-3.0981 -15)",
    style: {
      opacity: 0.73,
      fill: "url(#a74f7ef6-10e4-4a07-be54-91bdc2d16c79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.4016,444.0492c78.5756-37.9876,90.206-133.9055,1.3105-151.1695-52.12-10.1219-109.7147,21.8148-166.0842,55.9389-51.8272,31.3743-101.7814,11.2731-160.16,39.5439-71.3483,34.5512,12.0119,45.6312,100.9073,62.8952S325.4317,488.0289,416.4016,444.0492Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "url(#bd9b1cad-b29a-47b1-9f3b-5951ad1c63c6)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 328.8823,
    cy: 386.5,
    rx: 10.1029,
    ry: 4.5,
    style: {
      strokeMiterlimit: 10,
      strokeWidth: "6.410310000000001px",
      fill: "url(#e2acbb4c-62aa-4a20-b115-7157519550d4)",
      stroke: "url(#b9d0df59-2382-4608-94ef-aeecf27e1672)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.0729,
    cy: 358.4559,
    r: 10.1029,
    style: {
      strokeMiterlimit: 10,
      strokeWidth: "6.410310000000001px",
      fill: "url(#ab719951-9853-429f-a7d7-fc81afc8eb35)",
      stroke: "url(#b9153f8c-92a2-4608-925b-efcce3355203)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.9036,287.23a4.6669,4.6669,0,1,1-4.6669-4.6669A4.667,4.667,0,0,1,455.9036,287.23Z",
    transform: "translate(-3.0981 -15)",
    style: {
      opacity: 0.93,
      fill: "url(#b74041a5-982f-46b0-900c-8a516855f334)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.7074,373.1734c7.5727,0,13.6947-4.4959,13.6947-9.23,0-4.7229-8.9663-9.1694-16.49-10.0293-10.3176-1.1792-10.9,5.3064-10.9,10.0293C119.0127,368.6775,125.1416,373.1734,132.7074,373.1734Z",
    transform: "translate(-3.0981 -15)",
    style: {
      opacity: 0.89,
      fill: "url(#eabe4242-d200-46fb-80a8-aefcaaa132cf)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.4312,172.0713a20.2963,20.2963,0,1,1-16.1678-23.7173A20.2964,20.2964,0,0,1,139.4312,172.0713Z",
    transform: "translate(-3.0981 -15)",
    style: {
      opacity: 0.89,
      fill: "url(#bf5e3b3c-138a-4027-923a-32d16f885990)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.25,108v-1.3212h-.1277c-9.0126.7842-16.3176-6.5231-16.3162-15.5357a16.3185,16.3185,0,0,1,11.4006-15.5575c-.0608-.8429-.0935-1.6952-.0935-2.5537a34.4184,34.4184,0,0,1,60.919-21.9837A44.89,44.89,0,0,1,422.35,62.4514q0,2.2233-.2135,4.3874a13.7762,13.7762,0,0,1,3.66-1.3384c6.7883-1.4178,14.49,2.5365,18.8911,7.8759,5.2879,6.4035,2.6316,10.9062,9.77,20.6268a27.0256,27.0256,0,0,0,4.3266,5.0511c8.7749,7.51,23.961,8.4819,27.772,8.9458Z",
    transform: "translate(-3.0981 -15)",
    style: {
      opacity: 0.10000000149011612,
      isolation: "isolate",
      fill: "url(#f388994d-1a36-44fb-8e06-992c32865d1e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0325,178.7659a8.2343,8.2343,0,1,1-8.2344-8.2343A8.2343,8.2343,0,0,1,86.0325,178.7659Z",
    transform: "translate(-3.0981 -15)",
    style: {
      opacity: 0.89,
      fill: "url(#ac0a5b51-b499-48bb-8f26-0633f3a8ef0c)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.336 211.489 44.54 194.173 103.618 184.275 29.336 211.489",
    style: {
      fill: "#ffe380"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.336 211.489 46.927 239.027 103.618 184.275 29.336 211.489",
    style: {
      fill: "#ffab00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.039 219.014 46.927 239.027 103.618 184.275 23.039 219.014",
    style: {
      fill: "#ffab00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.618 184.275 0 245.299 23.039 219.014 103.618 184.275",
    style: {
      fill: "#ffe380"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "bbd88d99-fe9c-4c12-bcd0-a4af84775a5d",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "269.69 194.564 269.689 194.563 269.675 194.571 213.489 226.898 269.675 259.596 269.687 259.603 269.688 259.603 269.69 259.603 325.902 227.279 325.902 227.275 269.691 194.563 269.69 194.564",
    style: {
      opacity: 0.5,
      fill: "url(#ecb51dc8-1b7c-42cd-9a0b-725fab3dc606)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.621 225.892 214.621 225.891 158.387 193.166 158.386 193.167 158.385 193.166 102.167 225.496 158.385 258.212 158.4 258.221 158.401 258.22 158.403 258.221 214.621 225.892",
    style: {
      opacity: 0.5,
      fill: "url(#f0ccc704-3c26-4e71-896c-a71eba81660d)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.655 290.97 214.654 290.969 214.648 290.973 158.429 323.309 214.618 356.011 214.619 356.01 214.621 356.011 214.65 355.994 270.85 323.674 214.656 290.969 214.655 290.97",
    style: {
      opacity: 0.5,
      fill: "url(#e2abe583-c0e8-4ea9-a588-3965eb413921)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.392 65.058 158.393 65.057 158.395 65.059 158.869 64.786 214.606 32.716 158.388 0 158.387 0.001 158.387 0.001 158.386 0 158.385 0 102.16 32.333 158.385 65.053 158.392 65.058",
    style: {
      opacity: 0.05,
      fill: "url(#a93442bd-7961-4639-857c-6f46d7397220)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.628 162.811 214.629 162.811 214.631 162.812 214.65 162.801 270.849 130.478 214.65 97.773 214.621 97.757 214.621 97.758 214.621 97.758 214.618 97.756 214.618 97.757 158.397 130.087 214.628 162.811",
    style: {
      opacity: 0.5,
      fill: "url(#ada61ae2-39c3-492a-b941-38ae66e9cd69)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.909 226.969 213.907 226.968 213.902 226.971 213.902 292.303 213.917 292.313 268.902 324.311 268.902 324.66 269.902 324.661 269.902 259.586 269.902 259.554 213.909 226.969 213.909 226.969",
    style: {
      fill: "#4c9aff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.902 323.29 158.902 258.509 158.902 258.453 101.902 225.281 101.902 225.506 102.902 225.504 102.902 290.923 102.965 290.96 157.902 322.932 157.902 323.289 158.902 323.29",
    style: {
      fill: "#4c9aff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.908 323.4 158.908 323.4 158.907 323.4 158.902 323.403 158.902 388.413 158.948 388.441 214.902 421.003 214.902 421.07 214.902 421.071 214.902 355.984 214.894 355.981 158.908 323.4",
    style: {
      fill: "#4c9aff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.902 130.013 157.902 130.08 158.902 130.081 158.902 65.256 158.902 65.255 101.904 32.085 101.904 32.086 101.902 32.085 101.902 97.423 101.928 97.439 157.902 130.013",
    style: {
      fill: "#4c9aff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.902 130.094 158.902 195.212 158.915 195.219 214.902 227.8 214.902 227.867 214.902 227.868 214.902 162.752 214.9 162.751 158.902 130.162 158.902 130.095 158.902 130.094",
    style: {
      fill: "#4c9aff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.902 227.518 270.902 195.89 270.902 195.542 271.902 195.54 271.902 195.529 271.902 130.483 271.902 130.485 271.902 130.253 214.902 163.032 214.902 162.822 214.902 227.863 215.902 227.862 215.902 227.518",
    style: {
      opacity: 0.5,
      fill: "url(#a48ad440-f914-4f50-b74a-d14000a0f16b)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "270.904 128.681 270.904 128.682 270.902 128.68 270.902 193.468 270.933 193.487 326.9 226.056 326.9 226.055 326.902 226.056 326.902 161.286 326.902 161.269 270.904 128.681",
    style: {
      opacity: 0.5,
      fill: "url(#a175eabd-af2c-4f42-b63f-b41a05dd5c0d)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.902 128.868 383.902 128.645 326.923 161.428 326.902 161.441 326.902 226.185 326.912 226.192 326.913 226.191 326.914 226.192 382.902 193.996 382.902 193.922 382.902 128.866 383.902 128.868",
    style: {
      fill: "url(#e228332c-5aae-42f1-b5b8-4b610ba3850a)"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "214.902 32.762 159.381 64.69 158.908 64.961 158.902 64.966 158.902 130.013 158.913 130.02 158.914 130.019 158.915 130.02 214.902 97.824 214.902 97.757 214.902 97.749 214.902 32.696 214.902 32.697 214.902 32.762",
    style: {
      opacity: 0.5,
      fill: "url(#f56c34cd-bbb8-4088-95f5-56f5e3e8357a)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.902 226.08 269.942 258.843 269.902 258.865 269.902 323.599 269.908 323.602 269.909 323.602 269.911 323.603 325.902 291.401 325.902 291.316 325.902 226.303 326.902 226.304 326.902 226.08",
    style: {
      opacity: 0.5,
      fill: "url(#a1f1f08e-f1ae-4bf6-9296-746a924e81bb)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.902 225.639 158.965 257.958 158.902 257.994 158.902 323 157.902 323 157.902 323.284 158.902 323.283 158.902 323.223 158.902 323.223 158.902 323.217 214.902 291.015 214.902 290.937 214.902 225.93 214.902 225.931 214.902 225.639",
    style: {
      opacity: 0.5,
      fill: "url(#ef090978-968e-4eed-98bd-a2e89da5f47b)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.902 323.461 213.902 356.257 213.902 356.07 214.902 356.071 214.902 420.708 269.865 389.102 269.902 389.082 269.902 323.69 270.902 323.691 270.902 323.461",
    style: {
      opacity: 0.5,
      fill: "url(#a5a773f5-a4c5-4440-ae1e-9579d9b822ac)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("image", {
    width: 108,
    height: 99,
    transform: "translate(219.9019 130)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAABjCAYAAAB+MOUYAAAACXBIWXMAAAsSAAALEgHS3X78AAAJoUlEQVR4Xu1dQYvUTBB9yeyf9BfuRfEgCB4ED4rgwYMgCKIIIggiCCIKTtLfwa9mK5VXXdVxZ3cm8UGTTndVp9Ov63UnmdWulII14PLysty5c6eL7M4dF5HBqePu3btlHMfIbDU4W8Lu379fxnFEKQVrUYkMzo6wBw8ebCqiLPrI4JTw8OFDN5S6bvXLF4AzibBHjx4d5I+h67rNyOJJE/b48eNQ/rquQ2SzJpwkYU+ePCnZiBG7rP254+TWsKdPnxZvPdrKOlXDyUTY8+fPw3VqGAZatyXcOmEvXrxw5U+esUop1XVqS5F3a4S9fPnS3VAIAV3XzZIld0s7ROCW1rBXr14VIcCiddc3jmOT/bnjRiPs9evXdJ3KSh+zB7YVZTdC2Js3b6rPU1np86RyK2QBRybs7du3VaK2NNDXhaOtYe/evZutU1rKWsiSKGrxWSuuPcI+fPhwiCo7yEz6LFh5jSjWxppxbYR9/PiRyt8x15hjtn2quBZJ/PTpU9FRs3RD0Cp9LbZrwV9F2OfPn2fy17JOdV2Hvu8xjuPk+cuTyn9YSNiXL1/S8udFmWer833fo5TSHKlrRhNhX79+LZmB0wPskVV70WuRidatIL2Gffv2rfR93VyTJHkmZbW6FulrsV0Lwgj7/v17+tdJEll6w8G26RFaNiytbZ87XMJ+/PhRMiR5sJKoNxfeILcQBWxTKqnG/fz5czYKmYG0JNVmv63T65olYkmUrhWTCPv9+3fRW2s9aBFZwNRHS2LGN2PzD/8TNgyDK3+WBCAe3CxJNnKyfltGX9QIyeB5R2Aud+xYi0ypZ9LH4NltVSZ7duN6LfIGVduwIyOb1VtIf7ZIRgbhc5gduMxAZmwsWkgqpWzupwECSpiNDiZxNdm0PhZZYgCfyBaC14QJYUwKvYH3pFAQDaaVPnvN6yJ8bZgQpgfC5r1IasXSyFjis0ZUJVGgZ/x1SGIW3oM0sF0Cq5IoYIPTujvUfp70aZmsEbJVsoCkJOrz6BjVeWA23kSJ1rg1I5TEaLYLbHQyGV0Cb+JsFeFzmDf4HhmZqMpKn7aP6iObtSBcwyIJ1MfIxuY12NqW8dsKUQK6htkZmxmUmhQukUR2TU8eLblrhiuJbE2y5fqYkUIG7a9T7U+R+r6fkAVgM6+pXEkURDLHIrFmwyKxVh6hdYKcO6rb+sxgsEjMSKKOJgYrz13nfyvL9HMtqEpiRgoFWUnMTgSB9GErkheBSiIQy5uNAF12DByz7XOCK4nsvAYmYbaO+TA/LwptmyKTLWveuWMmiWxNsuXMhyXbJsPSwd4aUYLFkqjh1UVSuWTAW6J+jZhFmCdHDNZOCLBS10qMjp4WmdwCqCTWpJBJnSXEk8YarL0lIvtz8bWDRljmaPORjxcJ1sbaZkjaUpSFn1dq8KLBg7xSqkmcBzY5WqN4DTgQpuUtK4nMN7Jl2O12zSRm214besDfHbJoyAxoZCvtecRGfpHdmtEDU3LkHGiPFDaYLGpaZCyKvK2RdogwJoNs3WCIZn2WHKCNzC3isIbVBtpGXEYqmcxaZKNDTyjbh62h+i7RIqrXaLGtwYs2+W391qLxsIZZsAjyNgfsqG1rg5qNFNufraJna5fkPSnSNvbI1iA7yLXB92yZ3RbJc3+EUzvWoG0z9gxL/baAybZe8uwoYJsJZutFrq1nEdmCrZHbyw0zeZMjIymy1XY10m25J6lZqVw7wl/+Am2zuEbUEpRSJjtCSWyXeHl5uTxUzwRdKeXwL914x2EYZoNl88zWs9ODLflhGDAMw6Reyq0fs7PkrfV/6zsQxsiyZR5JzCdry0jwCPHqdbvAVHLXRlxVErtu/uxlzy2OvbaUcvWz7L7vJ2m3201+FQysTyZphNk8MP3iy/J2xtfsoghj57qs667+mSN9lHJ93bVFW0oSa4PObCOidJ2QwNaq/X4/KwP45JE6nbd1gnMmLkVYC3EZG5a8zQUA7Pf7gzzXrmcjD8ChDSnXOEfi6Bpmb8xbk/QDs/aRvG1HQ9Y6nQRCgmC321FfWbskz47yNXu32x3WOME5rm9hhAGgdczWRkDGR0cTa09fn7XPzm2S+2D2gnOJNpewlmevTF2GsNrgA6B9AuZvWkQGbV7s7TV0G6dOXPXvw6Ltua0XP2tjZY9t/bXMiYSJ5F1cXGC32+Hi4iLcxgOYlHuyacsknbpMViWxNWpa8hJVwzAc1kBrpyeQ9bVlpfx5PqtFoT63/REbyQOnGW3hc1ht8Jld1k8SwLfpmkSbZLtvk/axxOm22TWlTNcJTom4CWGtRGXyURk7r5ElSW9SPD8hFph/zpE2dL2eRGIjeeA0iHMjDIh3h9pen9u8HViAD6AdrCjZa9fajdrx7HSfgNsnbUZY9Lbdu8GoDJjv5loS87OyV2ubSaT2s9GmfYDTkcmZJHrRpfMekZ6NHZxaWRRltk4/DtSkNOqX1GlirL2deMDNE+fuEtlNekcvD1zdNNsJSpnY2cHzBs76SP8za984jpNos9e29wbMn9usH3BzxE0+YLKH1wyRNg/Uoyhr4yVgKlH20YD1iSUmg9aPtWEnk+RvgjS6S9SdisrkvDbDgfkf5Nn6Wj4aeK/dTNrv9/Salkz9Epn1S8qA4xI3k0Tdkeio7SM5AvLrkj6XPMClyfrpV1HZJH7ZMta+jTrgOMT99XMY4EubR6TU25tvyVvyWD88gpkt8wEwi8Ba28BcSa6btMWvpjQRwHRNYQPhldfsrI89z5CWvba28R6omZ933+N4nOc3VxI9AgFMjuzGdWc9G3bjutza1OqipO3ZAHvt6T6xCczatRGmbYG/J27yF5j6QvbNOnuzbet0vYW2ZeW1tm1fam17vmJn+2nrdXvysbPrrj6EylcC+2e+ut5e4zo/mnallBK93QDmsz2SQJtqdlEbXj0rX9KW3I93n3LsuvnXAGC+EREf7+2KYEm0zX5IatcpG+KZgQHqu7XIN7JpaSdbD9SlPGqvFH+TE/WjhbhuHMfZL3+B9pmbtVtaH/nV7CJfW7+kDW2jn9lsXS0AMsTN/ijdW0sYIruo3sKuIS3teu17ZbW2mS2D1wf54i1fyu1Xcrv+SfuZ9a0bx7G0zKIoRW2w+myZ195SZWits2Wef7bvYmulFPCjrRMDD79+/SpA/dVSS6czvp5dzVfXtV472kDZ8ujc1kWPLF4/gDlxIWG3hffv3xegLVo9+6XlegC9DcnSstq1ZQ0UG03ayRJ2W3j27Fk4UbIE/E2ZlMtEAf5E2z/CTgT37t0rjEBgStp/EYheSEYvVqIAAAAASUVORK5CYII=",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("image", {
    width: 108,
    height: 99,
    transform: "translate(162.9019 227)",
    xlinkHref: "data:image/png;base64,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",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("image", {
    width: 108,
    height: 33,
    transform: "translate(106.9019 195)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAAAhCAYAAAA8oE5/AAAACXBIWXMAAAsSAAALEgHS3X78AAAFQklEQVRoQ92bvVLkMBCEx/a+JK9IQERCQEZMSEBOkVIFVK0tW3MBtGm1x7sLt39eVaksaUZaPJ9bkuW7yt3tEtL19bUPw2BmZldXV9UW98WmaunAbm5uPOdsOWdzd8s5W1VV5u4XCW6xwG5vb50habmua7tExS0O2N3dneeczcxGIJHCcs7W973x/V0CuEUBu7+/977vra7riaIAyd3N3S2lNNrRZrZ8aIsA9vDw4MMwTIIPFTVNM5ahPvi5u3VdV/QzWy64swb2+PjoKaURRN/3hZKqqrJhGMZNBqZA2IdhGEGhDBvS0sCdJbCnpydv29agKr42TWN935uZjaAAQYHqtMggoUSkpYA7O2DPz8+eUrKu68zMRghQUkppBMXqAhD4cx3rHCuO+yAGS4B2NsBeX1/9/f29UBSvWVxGXZUz58/Ki1S3pGny5MDe3t68bVv7/PwsQAFcVVXjFMgBxk6RAc/BjGADZAQb6RzBnQxY27bedZ2llEZYyJgCEUie+hQEAwSAbesYspmNv4MHAz5mNsI7J3AnAebu3nWddV1nHx8f5u4jLABCEBG8ruuKuqrIzIqA6zqm6sRWXxWoYJHOBdpRgaWUfBgG6/ve+r6fQNKnP1ISK0h9deu+7Yq/gdXJ8DAexjc7PbhjAXMEAEFKKYWgWAUpJTOzol3rm5QUQWIlKRBAw29H/ZFOBe7QwFyBcLDMvqY63kDAh9ViZkUflKP3MA4s2vjFWv8OBqllBsobGyj8FNAOCcz1CY3ARW3YdES+2Bzo2WHO8VqFMsZDP8DftM3X8XOeHnu5H/czziGATb5P8ROvT3MUHPfy3YltUJYGc1vQWX2qTIaGl3OMzXXYWW1oOxa4fQLzCIzmKNBanoMQXbf5/LWf+kK9eFh4vdO//ZDg9gHM+Y/9bhhvmOtmNrk5zWpHH7Rvq8/BapqmUApnPe2PsvbXK693ZofblPwXMP/urKDmsvowUJ7+2A91Do5u65umMff45AJ2s68NTgQKfti5Irv75NsbfPg39F64/77B/RWYc79d4OxS5wCoXUFGfnOwYMfL95xvztPDYwUIaCjzeqpjcdu+wP0WmHOQ9MpBjNoiXwSHgx71R1+GqsHXcQCLx2KVwY/Lq9XK2rYtbBE0+EV2fZWBSvcBbVdgriB+e91kw5OqYDb1ZT+A4d0bK0tztJatVqsCCMCyH8qYSnPOtl6vi7FzLqdWnb7d/09tuwBzDRiXI9smu44RQYjauM52gEY9gq/9GBjAMhD4qtIYlELouq5Q1twJDo7Ccv6b4jYBcw2WGHdu17a5gKotAsO5rusiyDxWVI9sqp656y5l/tgKYDwFm5XHan+BFgHzoM247Tf2yBftLiC0j7ZF/u5eTIkRFM7YMc7tKOG3Wq3G8nq9ngQa/pyhQFYbrvg9VeFvj7kYmM8F99u4t7YITmSf64drVf3cIwccdYVX13XRn9c89Oe1TCFGmwwGxTAiaLhGh9rI28AB2EZYSNt85uzuX8rQ9Ub9I/Vg2tM+aFco7IcMVfE4Zj8fLxlKlNUOtWCsKPA550KZDDOlVEBEmc8+58BVOeftpDYkwOA6EgOCD26a69FY3I/7RO0AolMig1JYDI2BKBy16bczBTJ3aB3Z8V4IaJznoO2yS/xrKgb+7e/MgWc7pjhOCIa+g81d+ekGGF7f9KwQClFgUcb0mvOX2iIwqjTkpmnGMoM7JLCTpUyzBt+fAuNy3/cTOHOqc/cCGitJ37s0Y22LMv4DxybFXSSwY6eXl5fJJyXO2sb/PMLMZiFFKvwHA6Qiox+GwuEAAAAASUVORK5CYII=",
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "440.361 225.868 384.129 193.144 384.128 193.144 384.127 193.143 327.902 225.476 327.902 225.478 384.127 258.199 384.133 258.202 384.134 258.202 384.135 258.202 440.361 225.868",
    style: {
      opacity: 0.5,
      fill: "url(#f900595a-19b2-46eb-9b4a-75f66ae96441)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.904 225.683 327.904 225.684 327.902 225.682 327.902 290.47 327.933 290.489 383.9 323.058 383.9 323.057 383.902 323.058 383.902 258.288 383.902 258.271 327.904 225.683",
    style: {
      fill: "#4c9aff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.902 225.87 439.902 225.935 383.923 258.143 383.902 258.155 383.902 322.9 383.911 322.907 383.913 322.906 383.914 322.907 438.902 291.286 438.902 290.924 438.902 225.869 439.902 225.87",
    style: {
      opacity: 0.5,
      fill: "url(#bb182fbe-893b-4da1-80e3-bc71b234ff5a)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.825,
    y: 139.9349,
    width: 2,
    height: 36.5927,
    transform: "matrix(0.5385, 0.8427, -0.8427, 0.5385, 231.2321, -126.3631)",
    style: {
      fill: "#525e7a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.9019,
    y: 228,
    width: 4,
    height: 66,
    style: {
      fill: "#525e7a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.047 189.828 274.952 188.624 287.31 195.381 287.405 196.585 275.047 189.828",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.047 184.9 274.952 183.696 287.31 190.453 287.405 191.657 275.047 184.9",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.047 179.972 274.952 178.768 287.31 185.524 287.405 186.729 275.047 179.972",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.047 175.044 274.952 173.84 287.31 180.596 287.405 181.801 275.047 175.044",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.047 170.116 274.952 168.911 281.649 172.572 281.744 173.777 275.047 170.116",
    style: {
      fill: "#ffc400"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.047 165.188 274.952 163.983 287.31 170.74 287.405 171.945 275.047 165.188",
    style: {
      fill: "#ffc400"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.047 160.259 274.952 159.055 287.31 165.812 287.405 167.016 275.047 160.259",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.047 155.331 274.952 154.127 281.483 157.698 281.578 158.902 275.047 155.331",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.047 150.403 274.952 149.199 287.31 155.955 287.405 157.16 275.047 150.403",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.047 145.475 274.952 144.27 287.31 151.027 287.405 152.232 275.047 145.475",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.047 140.547 274.952 139.342 287.31 146.099 287.405 147.304 275.047 140.547",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.816 197.88 289.721 196.675 302.08 203.432 302.174 204.637 289.816 197.88",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.816 192.952 289.721 191.747 302.08 198.504 302.174 199.709 289.816 192.952",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.816 188.024 289.721 186.819 302.08 193.576 302.174 194.781 289.816 188.024",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.816 183.096 289.721 181.891 302.08 188.648 302.174 189.853 289.816 183.096",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.816 178.168 289.721 176.963 296.418 180.624 296.513 181.829 289.816 178.168",
    style: {
      fill: "#ffc400"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.816 173.24 289.721 172.035 302.08 178.792 302.174 179.996 289.816 173.24",
    style: {
      fill: "#ffc400"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.816 168.311 289.721 167.107 302.08 173.863 302.174 175.068 289.816 168.311",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.816 163.383 289.721 162.178 296.253 165.75 296.348 166.954 289.816 163.383",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.816 158.455 289.721 157.25 302.08 164.007 302.174 165.212 289.816 158.455",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.816 153.527 289.721 152.322 302.08 159.079 302.174 160.284 289.816 153.527",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.816 148.599 289.721 147.394 302.08 154.151 302.174 155.355 289.816 148.599",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.816 205.88 305.721 204.675 318.08 211.432 318.174 212.637 305.816 205.88",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.816 200.952 305.721 199.747 318.08 206.504 318.174 207.709 305.816 200.952",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.816 196.024 305.721 194.819 318.08 201.576 318.174 202.781 305.816 196.024",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.816 191.096 305.721 189.891 318.08 196.648 318.174 197.853 305.816 191.096",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.816 186.168 305.721 184.963 312.418 188.624 312.513 189.829 305.816 186.168",
    style: {
      fill: "#ffc400"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.816 181.24 305.721 180.035 318.08 186.792 318.174 187.996 305.816 181.24",
    style: {
      fill: "#ffc400"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.816 176.311 305.721 175.107 318.08 181.863 318.174 183.068 305.816 176.311",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.816 171.383 305.721 170.178 312.253 173.75 312.348 174.954 305.816 171.383",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.816 166.455 305.721 165.25 318.08 172.007 318.174 173.212 305.816 166.455",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.816 161.527 305.721 160.322 318.08 167.079 318.174 168.284 305.816 161.527",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.816 156.599 305.721 155.394 318.08 162.151 318.174 163.355 305.816 156.599",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.12,202.0086a17.4892,17.4892,0,0,0-2.9221,6.357,2.193,2.193,0,0,0-.1506.4487,2.17,2.17,0,0,0-.0512.4694v10.3436l1.5625-.0206c.0645-.951.1444-1.7235.2049-2.236a59.0849,59.0849,0,0,0,.75-6.6048c0-.5567-.0113-1.0091-.0246-1.29a3.5827,3.5827,0,0,1,.1322-.5726,3.9738,3.9738,0,0,1,.7736-1.3621c.5317-.6439,1.6874-2.2294,3.2571-4.3884Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#cf9e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.2392,205.311c-.1547-.1145-.9508-.6073-1.588-1.0476a17.8918,17.8918,0,0,1,1.5491-2.5457l3.53,1.1424c-.9457,1.301-1.7418,2.3881-2.3371,3.1916C280.8837,205.7175,280.3786,205.4143,280.2392,205.311Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#ff991f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5732,191.0276c.9344-.6214,2.6936-.2816,3.7971.5463a3.6226,3.6226,0,0,1,1.3575,2.1356,2.9611,2.9611,0,0,1,1.5922,2.8161,3.0759,3.0759,0,0,1-1.4784,2.191,4.1391,4.1391,0,0,1-3.4836.0113C283.43,197.378,282.7751,192.2217,284.5732,191.0276Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#172b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.1787,238.995a21.54,21.54,0,0,1-.0594-5.2727c.0645-.5689.15-1.1143.249-1.6334a19.5868,19.5868,0,0,1-.7326-3.5737c-.1086-1.0062-.2849-3.4206-.2931-4.37a9.79,9.79,0,0,0-.085-1.1265c-.0164-.1267-.0389-.2535-.0779-.4562-.2561-1.3274-1.3944-6.9746-1.0952-9.0238a15.4662,15.4662,0,0,1,.5666-2.4548,5.7829,5.7829,0,0,1,.2459-.7509,5.8433,5.8433,0,0,1,.41-.8289,8.0067,8.0067,0,0,0,.79.1831c.2961.0535.5267.0741.6486.0938.6987.0939,2.0317.2375,5.6239.4891a9.5951,9.5951,0,0,1,.6752.8683,9.8489,9.8489,0,0,1,1.4231,3.14,123.9482,123.9482,0,0,1,2.9231,12.7768h0l1.0656,5.4623q.0492,1.578.1588,3.2414.123,1.8774.3074,3.65l-3.2244.3492a13.9285,13.9285,0,0,1-.2551-2.6059,13.6549,13.6549,0,0,0-.0861-3.2319,7.3628,7.3628,0,0,0-.4364-1.378,19.6956,19.6956,0,0,1-1.0471-2.0558A28.0032,28.0032,0,0,1,291.4839,226c-.835-2.8565-2.503-5.375-2.9087-5.252-.5594.168,1.8442,5.2051.417,10.3258a8.5277,8.5277,0,0,0-.4949,2.0022,9.9979,9.9979,0,0,0,.11,2.3769,17.5483,17.5483,0,0,1,.0122,3.4882Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#cf9e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.11,201.759a5.5242,5.5242,0,0,1,2.3853-1.7836c1.6229-.6139,4.3114-.5041,6.54-.6317a14.5309,14.5309,0,0,0,4.8063-.751c1.1271-.4309,1.7531-.8908,3.6547-1.6343,1.002-.3924,1.8442-.6637,2.4211-.8355a12.4705,12.4705,0,0,1,.2684-2.5974c.4037-1.9121,1.04-2.6837,1.4549-4.549a12.3762,12.3762,0,0,0,.2869-2.9588c.1844-.0122.4528-.0356.7828-.0817l.1168-.0169c.2131-.0309.5184-.0826.9067-.1671a38.7555,38.7555,0,0,1-.8637,11.5509,23.4112,23.4112,0,0,1-7.8626,4.7132,6.4543,6.4543,0,0,0-3.8083,2.5693,3.67,3.67,0,0,0-.3822,1.61,8.8952,8.8952,0,0,0,.9549,4.7217q-2.0788.1876-4.2008.3539-2.6433.2083-5.2253.3755a19.4238,19.4238,0,0,0-.94-6.8188A19.74,19.74,0,0,0,281.11,201.759Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#cf9e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.4984,195.9286a2.718,2.718,0,0,0-1.0359,2.4,2.533,2.533,0,0,0,.8842,1.4888l-5.0286.58a1.8113,1.8113,0,0,0-.0635-2.69Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#b08874"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.7135,191.0051a9.1668,9.1668,0,0,1,1.69,2.3468c.045.107.0573.1586.2991.2731s.5646.1587.5052.3229-.41.3849-.4447.5257l.3811,2.267-.99.3755-3.3494,1.2532c.04-.1249,1.2172-3.2217,1.2049-3.3991s-.0573-.5445.164-.6421a10.5082,10.5082,0,0,0,.6465-2.144.8386.8386,0,0,0,.0072-.6383C286.7566,191.2107,286.7135,191.0051,286.7135,191.0051Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#cf9e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.5729,182.8017c.0922.0591.1148,0,.372.076a1.7235,1.7235,0,0,1,.5819.3014,1.4079,1.4079,0,0,1,.3976.87,2.6085,2.6085,0,0,1,.0338,1.0889,2.0633,2.0633,0,0,1-.38.9387c-.36.4693-1.0553.9021-1.3965.7265-.1834-.0939-.1711-.3144-.254-.7875-.1752-.9923-.3935-.9538-.4765-1.6015-.0871-.6683.1578-.6195.3812-2.2529.0871-.6345.1168-1.1264.249-1.1405.0963-.0075.1926.2431.2325.3492C303.5863,182.0827,303.283,182.6158,303.5729,182.8017Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#cf9e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.0075,202.0143c-1.6947.751-3.1465,1.3714-3.8084,2.5692a4.061,4.061,0,0,0-.3822,1.61c-.0737,3.3888,5.6352,19.7317,6.1137,21.1022a20.3934,20.3934,0,0,1-14.8984,2.5252,68.2855,68.2855,0,0,1-.3258-9.95c.0451-5.78.9447-8.6408-.0512-13.49a17.1283,17.1283,0,0,0-2.459-4.6663,6.4137,6.4137,0,0,1,2.043-1.5958,7.4585,7.4585,0,0,1,2.4426-.674,38.6367,38.6367,0,0,1,5.3493-.1061,18.987,18.987,0,0,0,4.4467-.735Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#ffab00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.7566,191.0389a3.4807,3.4807,0,0,1,.1793.9922,4.1,4.1,0,0,1-.205,1.3452c-.2961,1.0842.2992,1.5827.4457,3.03a3.8825,3.8825,0,0,1-.6352,3.1607,3.7008,3.7008,0,0,1-3.8545.7885,2.8574,2.8574,0,0,1-1.8166-1.8211,2.2821,2.2821,0,0,1,.1609-1.4644,4.4231,4.4231,0,0,1-.2725-3.079,4.3069,4.3069,0,0,1,1.9-2.5673A5.2322,5.2322,0,0,1,286.7566,191.0389Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#172b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.2126,218.7524l-.041.1878a7.9839,7.9839,0,0,0-.0952,3.936s.7172.751,1.127.6571h0a.7208.7208,0,0,0,.5656-.5933l.2643-2.005.22,1.0326s.2295.1154.2961.061c.16-.1305.1025-.6778.1025-.6778a6.2207,6.2207,0,0,0-.5882-2.633l-.3545-.7613-1.501.7988",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#cf9e76"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.862 162.058 327.862 162.057 327.865 162.059 328.338 161.786 384.075 129.716 327.857 97 327.857 97.001 327.856 97.001 327.855 97 327.854 97 271.629 129.333 327.854 162.053 327.862 162.058",
    style: {
      opacity: 0.05,
      fill: "url(#bd26f76f-8f02-49c8-9e0b-40184450780f)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.69 354.918 327.689 354.917 327.675 354.925 271.489 387.252 327.675 419.949 327.687 419.957 327.688 419.956 327.69 419.957 383.902 387.632 383.902 387.629 327.691 354.917 327.69 354.918",
    style: {
      opacity: 0.5,
      fill: "url(#a326a6fb-1a68-4a14-92a7-9afca34aa07c)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.9019,
    y: 233,
    width: 2,
    height: 65,
    style: {
      fill: "url(#fd6c61e2-4329-4d64-adfc-a5cc75adc0b8)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "106.117 236.922 153.539 265.832 153.539 312.926 106.117 284.016 106.117 236.922",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px",
      stroke: "url(#b7b2cfc8-fb44-4be0-ab3b-178685d9787b)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.1173,
    y1: 279.3062,
    x2: 153.5389,
    y2: 308.2162,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px",
      stroke: "url(#bb0b558d-307d-4919-b643-fefac43ce753)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.1173,
    y1: 274.5968,
    x2: 153.5389,
    y2: 303.5069,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px",
      stroke: "url(#ecacab6c-af32-4305-90c8-4ef52b4a7ab7)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.1173,
    y1: 269.8875,
    x2: 153.5389,
    y2: 298.7976,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px",
      stroke: "url(#a61d771a-b867-4413-9015-8dd22e0a8785)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.1173,
    y1: 265.1782,
    x2: 153.5389,
    y2: 294.0882,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px",
      stroke: "url(#e46a541b-a525-41b4-a268-f00a9b452648)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.1173,
    y1: 260.4689,
    x2: 153.5389,
    y2: 289.3789,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px",
      stroke: "url(#b63dba73-f2c5-4b90-8c0a-b926e9de9e6a)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.1173,
    y1: 255.7596,
    x2: 153.5389,
    y2: 284.6696,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px",
      stroke: "url(#b8febaa3-6627-45b0-84f2-88bac111e981)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.1173,
    y1: 251.0502,
    x2: 153.5389,
    y2: 279.9603,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px",
      stroke: "url(#f39a9be9-f2fb-4290-9ca3-b0b394fb62f6)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.1173,
    y1: 246.3409,
    x2: 153.5389,
    y2: 275.251,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px",
      stroke: "url(#ac7bf252-f896-4970-a3b2-194cb8079e58)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.1173,
    y1: 241.6316,
    x2: 153.5389,
    y2: 270.5416,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px",
      stroke: "url(#a0c8097c-a387-4580-a1d1-6509f525738c)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.6112,
    y1: 262.2185,
    x2: 147.6112,
    y2: 309.3118,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px",
      stroke: "url(#bb45b82e-d37c-461c-a0de-ce99fd6e5cda)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.6835,
    y1: 258.6048,
    x2: 141.6835,
    y2: 305.6981,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px",
      stroke: "url(#a9f645ea-db9b-47aa-a7fd-3f9c9f1a5673)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.7558,
    y1: 254.991,
    x2: 135.7558,
    y2: 302.0843,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px",
      stroke: "url(#bf76642f-8da9-45c0-a172-a3e96a3c810d)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.8281,
    y1: 251.3773,
    x2: 129.8281,
    y2: 298.4705,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px",
      stroke: "url(#b0cf2261-d01b-4a5c-b971-4d98fb612cc2)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.9004,
    y1: 247.7635,
    x2: 123.9004,
    y2: 294.8568,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px",
      stroke: "url(#acce527f-4e9f-4b95-974e-af6e0eb7206b)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117.9727,
    y1: 244.1497,
    x2: 117.9727,
    y2: 291.243,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px",
      stroke: "url(#a9c6d260-e6fa-404b-9a74-3e52d2ae07cf)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.045,
    y1: 240.536,
    x2: 112.045,
    y2: 287.6293,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "0.25px",
      stroke: "url(#efc78f4e-74fa-4d19-9f8f-78f8237a6a52)"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "153.539 294.088 147.611 262.219 141.681 277.526 135.749 264.443 129.816 274.956 123.899 261.917 117.967 263.034 112.066 268.905 106.117 260.469 106.117 284.016 153.539 312.926 153.539 294.088",
    style: {
      mixBlendMode: "screen",
      fill: "url(#a5e2f2f9-5feb-4d66-8d7d-72b51192b681)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.9019,
    y: 231,
    width: 2,
    height: 65,
    style: {
      fill: "url(#fa2ee24f-494f-4ad9-a2d4-a86290546a62)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.182 305.902 407.29 297.063 407.421 298.423 390.314 307.262 390.182 305.902",
    style: {
      fill: "url(#b69614c1-9c6d-4904-b0ca-143e7340581c)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.818 252.712 389.902 262.369 389.947 300.742 407.902 291.471 407.818 252.712",
    style: {
      fill: "#deebff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.056 292.704 398.786 289.295 395.646 281.81 392.056 292.704",
    style: {
      fill: "#b2d4ff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.739 291.342 406.108 285.583 400.802 272.94 394.739 291.342",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 398.2458,
    cy: 286.8019,
    rx: 2.8978,
    ry: 1.017,
    transform: "translate(79.3006 647.4289) rotate(-85.7011)",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.217 265.665 432.324 256.825 432.456 258.185 415.348 267.024 415.217 265.665",
    style: {
      fill: "url(#f9db450b-ace9-40af-bc09-24f07c7d6c51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.216 259.562 432.324 250.722 432.455 252.082 415.348 260.921 415.216 259.562",
    style: {
      fill: "url(#b4858666-5609-449f-9795-0c78f1d5fa9d)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.217 253.46 432.324 244.62 432.456 245.98 415.348 254.819 415.217 253.46",
    style: {
      fill: "url(#a286c831-031e-417f-8814-aa02985ef1fd)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.902 277.952 217.902 247.93 217.902 247.048 269.902 277.07 269.902 277.952",
    style: {
      fill: "url(#f1453355-f8ec-4c26-8ef5-84d7086e5285)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.902 294.488 217.902 264.466 217.902 263.585 269.902 293.607 269.902 294.488",
    style: {
      opacity: 0.5,
      fill: "url(#f5194b6d-a3b3-4863-9025-0d58246ebab3)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.902 310.488 217.902 280.466 217.902 279.585 269.902 309.607 269.902 310.488",
    style: {
      opacity: 0.5,
      fill: "url(#b2918eac-06b4-441d-b2d1-051ba5529d7e)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.902 277.952 217.902 247.93 217.902 247.048 269.902 277.07 269.902 277.952",
    style: {
      opacity: 0.5,
      fill: "url(#f1453355-f8ec-4c26-8ef5-84d7086e5285)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.902 245.146 269.902 277.478 269.902 276.596 325.902 244.265 325.902 245.146",
    style: {
      opacity: 0.5,
      fill: "url(#a4a69084-eee4-49ae-ac3b-7bf90a66265d)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.902 261.427 269.902 293.758 269.902 292.877 325.902 260.545 325.902 261.427",
    style: {
      opacity: 0.5,
      fill: "url(#e910bbba-3cd4-4a9b-af69-0cc03f4f1f95)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.902 278.427 269.902 310.758 269.902 309.877 325.902 277.545 325.902 278.427",
    style: {
      opacity: 0.5,
      fill: "url(#bf789a93-aea7-4d90-96e6-85e583f837c9)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.902 309.778 255.902 308.624 255.902 306.624 257.902 307.778 257.902 309.778",
    style: {
      fill: "#d92f15"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.902 312.088 259.902 310.933 259.902 308.933 261.902 310.088 261.902 312.088",
    style: {
      fill: "#ffcd1c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.902 314.397 263.902 313.243 263.902 311.243 265.902 312.397 265.902 314.397",
    style: {
      fill: "#ffcd1c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.902 312.778 255.902 311.624 255.902 309.624 257.902 310.778 257.902 312.778",
    style: {
      fill: "#008252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.902 315.088 259.902 313.933 259.902 311.933 261.902 313.088 261.902 315.088",
    style: {
      fill: "#ffcd1c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.902 317.397 263.902 316.243 263.902 314.243 265.902 315.397 265.902 317.397",
    style: {
      fill: "#ffcd1c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "ad85b337-fd90-4199-a658-db8f68f83ff1",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.4985,269.5H219.5V240.289c.0065-5.2791,5.3629-9.5579,11.9736-9.5647,7.7429-.007,14.0175-5.0178,14.0264-11.2011V200.5h-2v19.0215c-.0064,5.2788-5.3627,9.5573-11.9732,9.5641-7.7428.0077-14.0171,5.0181-14.0268,11.2011Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#525e7a",
      stroke: "#525e7a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.5,241.5h2V209.7415c.0035-3.16,2.9195-5.7214,6.5185-5.7255,4.6826-.005,8.4769-3.3374,8.4815-7.449V184.5h-2v12.067c-.0038,3.16-2.92,5.7214-6.5189,5.7254-4.6823.0054-8.4761,3.3376-8.4811,7.4491Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#525e7a",
      stroke: "#525e7a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 231.2724,
    cy: 167.5972,
    rx: 3.9438,
    ry: 4.416,
    style: {
      fill: "#525e7a"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.9581,
    cy: 183.8214,
    rx: 3.9438,
    ry: 4.416,
    style: {
      fill: "#525e7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.0021,201H191v-1.5658c-.0066-5.12-3.801-9.2682-8.4824-9.2732-3.5985-.0051-6.5142-3.1949-6.5176-7.1305V168h-2v15.029c.0073,5.1185,3.8008,9.2654,8.4815,9.2717,3.599.005,6.515,3.1949,6.5185,7.13Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#525e7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,244h2v-1.8719c-.0083-9.3245-6.7-16.8819-14.9579-16.8938-7.2-.01-13.0346-6.5991-13.0421-14.729V209h-2v1.5053c.0086,9.3245,6.7,16.8815,14.9586,16.8929,7.2.01,13.0347,6.6,13.0414,14.73Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#525e7a"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.1482,
    cy: 190.0768,
    rx: 4.9724,
    ry: 5.5677,
    style: {
      fill: "#525e7a"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.4204,
    cy: 125.0963,
    rx: 4.9724,
    ry: 3.9037,
    style: {
      fill: "#525e7a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.9019,
    y: 135,
    width: 2,
    height: 18,
    style: {
      fill: "#525e7a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 137,
    width: 2,
    height: 18,
    transform: "matrix(0.5385, 0.8427, -0.8427, 0.5385, 203.9292, -100.9777)",
    style: {
      fill: "#525e7a"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 171.3607,
    cy: 155.9323,
    rx: 4.9724,
    ry: 5.5677,
    style: {
      fill: "#525e7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.998,200H189v-1.5658c.0061-5.12,3.5476-9.2682,7.9169-9.2732,3.3586-.0051,6.08-3.1949,6.0831-7.1305V167h2v15.029c-.0068,5.1185-3.5474,9.2654-7.9161,9.2717-3.359.005-6.0807,3.1949-6.0839,7.13Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#525e7a"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.5556,
    cy: 131.4863,
    rx: 4.9724,
    ry: 3.9037,
    style: {
      fill: "#525e7a"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.5822,
    cy: 229.4629,
    rx: 3.9438,
    ry: 4.416,
    style: {
      fill: "#525e7a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "ee3f529a-49ae-4065-9fcf-eb3d294a56df",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.4917,73.9347c-2.6477-1.1524-5.2611,1.9116-11.64,1.1094-.512-.0584-.8707.4225-.86,1.1529.2866,16.9661,6.1466,30.2417,12.508,38.0665,6.3529-2.2988,12.2129-10.4655,12.4995-27.1821a2.477,2.477,0,0,0-.86-1.9012c-6.3787-4.7544-8.992-10.0893-11.64-11.2418Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "url(#a835363d-79f8-4779-8e9b-32a33f27db6f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.4917,75.66c.9027.3929,2.0059,1.6643,3.4043,3.3134a47.6939,47.6939,0,0,0,7.8487,7.6848c-.1433,7.4187-1.4328,13.4959-3.8,18.0794a15.6634,15.6634,0,0,1-7.45,7.5062,51.5993,51.5993,0,0,1-7.45-13.9916,67.0641,67.0641,0,0,1-3.8-21.3871,17.9132,17.9132,0,0,0,7.8487-.8526c1.3984-.416,2.5016-.7429,3.4043-.35",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#deebff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.5838,92.668l-1.6878-3.0648c-.0927-.1676-.2425-.2327-.3352-.1459l-5.029,4.683-2.3182-4.02c-.0921-.1622-.2375-.2255-.33-.1434l-1.6878,1.5955a.4145.4145,0,0,0-.0017.4636l.0017.0033,4.1722,7.3545c.0925.1649.24.2291.3324.1447l6.8773-6.4461a.4164.4164,0,0,0,0-.4629Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "url(#b9d398f8-765c-46db-8f22-8b0cfccde61d)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "f511d995-94ae-4254-abed-4fdcaffe38cd",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.059,348.3517c-8.6772-14.423,2.8251-14.9381,0-23.0081-2.834-8.0951-10.09-7.04-8.879-14.2512C337.7168,301.9389,334.162,299,329.3189,299s-10.593,4.81-8.0718,13.1226c1.6144,5.3227-1.009,6.6963-4.6413,11.1606s-2.6233,10.9889,0,14.2513c3.388,4.2132,2.8626,6.823-.6054,10.9889-3.43,4.1208-4.0359,12.706,2.4216,15.4532s.6707,13.7568,4.6413,18.8872c5.4484,7.04,13.1167,7.04,15.9418-5.6662,1.8924-8.511-1.009-8.7568,2.6233-13.221S349.5824,355.8705,345.059,348.3517Zm-25.4262-12.5343c-3.9092-2.0492,2.8521-8.4718,3.9882-8.6653,0,0,3.386-2.1854,6.2269-.1553s-.8854,5.279-3.6806,6.4589S323.5418,337.8667,319.6328,335.8174Zm12.9149-25.7553c-1.8162,0-1.2108,3.2624-3.8342,2.5756s-.7251-6.1612,1.4126-6.01C332.5477,306.8,334.3638,310.0621,332.5477,310.0621Zm2.1543,43.051c-1.652-3.01,2.0873-6.2966,5.5044-4.6889a3.398,3.398,0,0,1,1.8256,1.9879c1.4126,3.9492,4.0359,6.1813.6054,6.5247C340.2265,357.1781,336.32,356.0626,334.702,353.1131Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "url(#e9ee71f5-3e9b-4d1d-89f9-189541c3b282)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a1ab52db-fab9-4584-afc8-5163a30189b7)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.0453,305.5979c.2018-4.4643,23.0315-12.57,10.09,13.7362-7.2646,14.7663,2.4763,14.374,7.0628,9.1,7.4664-8.5851,15.75.3241,2.22,10.6455-11.7042,8.9285-17.1526,14.2513-17.1526,19.0589s3.1284,11.1047,9.2826,9.2719c8.0718-2.4038,8.4753,26.27-14.1257,21.2911-11.1488-2.4563-17.3544-9.4436-16.749-31.7649S320.8435,310.0621,321.0453,305.5979Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "url(#fd7fc85a-ea3c-4c40-bb7f-bb5de9729c14)"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "328.754 318.319 330.369 387 325.526 387 327.14 318.319 328.754 318.319",
    style: {
      fill: "#005541"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "b9c04a77-e842-4192-93d6-1022e6659adf",
    "data-name": "Layer 8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.9011,406.79a.5894.5894,0,0,0-.2964-.5114l-2.0181-1.1305a22.9209,22.9209,0,0,0-1.962,1.6516l3.6677,2.1382a.42.42,0,0,0,.6387-.3589Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "url(#a4dd42f3-3dfb-4d3b-9ff6-dd92eba34b8b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.7357,406.776a1.4905,1.4905,0,0,1-1.4909,0l-2.0258-1.2785-.0014,1.7616a.5148.5148,0,0,0,.2574.4458l1.8852,1.0884a1.26,1.26,0,0,0,1.26,0l1.8851-1.0883a.5148.5148,0,0,0,.2575-.4459v-1.8078Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "url(#b65cdfa0-dd97-4aaa-9a5b-359a49f80d96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.5866,405.1482l-2.089-1.1968a1.0216,1.0216,0,0,0-1.0147,0l-2.089,1.1968a.35.35,0,0,0-.1749.3492.3258.3258,0,0,0,.0116.04.3429.3429,0,0,0,.1633.2167l2.089,1.1967a1.0213,1.0213,0,0,0,1.0147,0l2.089-1.1969a.391.391,0,0,0,.1734-.2583A.3469.3469,0,0,0,184.5866,405.1482Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.4734,389.9686a.5893.5893,0,0,0-.2964-.5113l-2.0181-1.13a22.9382,22.9382,0,0,0-1.962,1.6515l3.6676,2.1383a.42.42,0,0,0,.6388-.3589Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "url(#af04084c-d0cd-4d89-ae2e-a6dfb2b3b5de)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.3079,389.9546a1.4908,1.4908,0,0,1-1.4908,0l-2.0258-1.2785-.0014,1.7615a.5147.5147,0,0,0,.2574.4458l1.8852,1.0884a1.26,1.26,0,0,0,1.26,0l1.8851-1.0884a.5147.5147,0,0,0,.2575-.4459V388.63Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "url(#abfb0c03-4093-4a0d-b49b-e344aad10071)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.1589,388.3268,194.07,387.13a1.0213,1.0213,0,0,0-1.0147,0l-2.089,1.1968a.35.35,0,0,0-.1749.3492.4328.4328,0,0,0,.1749.2567l2.089,1.1968a1.0211,1.0211,0,0,0,1.0147,0l2.089-1.1968a.3428.3428,0,0,0,.1633-.2166.3375.3375,0,0,0,.01-.0417A.3468.3468,0,0,0,196.1589,388.3268Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.4734,366.9686a.5893.5893,0,0,0-.2964-.5113l-2.0181-1.13a22.9382,22.9382,0,0,0-1.962,1.6515l3.6676,2.1383a.42.42,0,0,0,.6388-.3589Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "url(#ab60d5c1-d54a-4080-a2b2-a0259ef65b1c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.3079,366.9546a1.4908,1.4908,0,0,1-1.4908,0l-2.0258-1.2785-.0014,1.7615a.5147.5147,0,0,0,.2574.4458l1.8852,1.0884a1.26,1.26,0,0,0,1.26,0l1.8851-1.0884a.5147.5147,0,0,0,.2575-.4459V365.63Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "url(#b43db1f6-daac-4c08-acd3-7c7d4398ff4c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.1589,365.3268,185.07,364.13a1.0213,1.0213,0,0,0-1.0147,0l-2.089,1.1968a.35.35,0,0,0-.1749.3492.4328.4328,0,0,0,.1749.2567l2.089,1.1968a1.0211,1.0211,0,0,0,1.0147,0l2.089-1.1968a.3428.3428,0,0,0,.1633-.2166.3375.3375,0,0,0,.01-.0417A.3468.3468,0,0,0,187.1589,365.3268Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.09,406.9048a5.2993,5.2993,0,0,1-.3984.3869,8.9829,8.9829,0,0,0-1.138,1.2746,1.3065,1.3065,0,0,1-.7567.5292.8724.8724,0,0,1-1.0641-.7511c-.0057-.0513-.0171-.148-.0227-.239,0-.0455-.0058-.0854-.0058-.131a.9812.9812,0,0,1-.0056-.1194c-.0058-.2162-.0113-.4609-.0171-.6942a12.5965,12.5965,0,0,0-.1137-1.5362c-.057-.4439-.131-1.0243-.2049-1.6957l2.3556-.3471-.1592,2.06a2.5576,2.5576,0,0,1,.91-.552c.1024-.0227.2049-.0455.3016-.0625l.1707-.0342a.68.68,0,0,1,.7056.3528c.0171.04.04.08.0511.1138A1.8085,1.8085,0,0,1,182.09,406.9048Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#171f40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.5816,395.0888l-.6482,10.3678c-.0588.7955-2.8381,1.16-2.8381.1935,0,0-.6654-8.92-.2963-11.9752l-3.6638-11.5029,6.6212-.0213.8131,11.1414A7.4354,7.4354,0,0,1,181.5816,395.0888Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "url(#eafe3b0a-d083-458b-b307-e31b8fefb609)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.0688,386.9232a17.341,17.341,0,0,1,.4347,2.785,2.1318,2.1318,0,0,0,.5682,1.205c.5611.4614,1.3823-.0086,2.0209-.355l1.8914-1.0067A1.8413,1.8413,0,0,0,195,388.0222a.6029.6029,0,0,0-.6689-.49l-1.5841.344a1.5654,1.5654,0,0,1-1.2429-.1729.5961.5961,0,0,1-.2869-.4823c-.0324-.4834-.0885-1.2169-.1635-2.1385A16.7077,16.7077,0,0,0,189.0688,386.9232Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#171f40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.746,387.9208c.1341.6318,2.87.1265,2.9341-.6824,0,0,0-5.7315-.4427-10.8831l-3.9242,1.33S188.6831,387.6242,188.746,387.9208Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "url(#a34a1c78-1159-42c9-bc27-b2f864b4fef7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.0691,375.5036a1.9007,1.9007,0,0,1-.3582,2.1015c-.9867,1.03-2.6176,2.7369-3.9836,4.1678a9.7562,9.7562,0,0,1-7.4232,3.0691c-1.063-.0441-4.3012-.8647-5.1689-2.67a6.7208,6.7208,0,0,1-.3255-3.0823,13.4743,13.4743,0,0,0-.0116-1.9721,1.876,1.876,0,0,1,.8069-1.6936c1.4607-.9958,4.3777-2.32,6.5531.9479.0667.1.1681.2519.2865.4313a1.9837,1.9837,0,0,0,2.8251.5122l4.0316-2.62A1.9017,1.9017,0,0,1,191.0691,375.5036Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "url(#bdc5e6fe-bee2-4e3e-9f97-1b22c37b9b56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.4091,360.7292c-.0264,2.1754-1.3822,2.6387-2.8107,2.2554a4.8222,4.8222,0,0,1-3.1367-3.209,2.9021,2.9021,0,0,1,2.0348-3.7693C179.0559,355.073,179.4183,359.9757,179.4091,360.7292Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#cf9e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.0094,359.729l.4455,5.3356a1.0911,1.0911,0,0,0,.57.4539,2.3151,2.3151,0,0,0,1.8082-.3137.8592.8592,0,0,0,.2248-.415l-.4455-5.3357Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#cf9e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.75,354.0054c-.0917-.1007-.1689-.1879-.1689-.1879s-.2133-.6178-.5667-.6435c-.6142-.0447-.9145,1.24-.9145,1.24s.1334-.618.1716-.8426a.5082.5082,0,0,0-.2429-.5468c-.2918-.1145-.3453.1893-.3572.3722l-.6509,1.5432a1.9991,1.9991,0,0,0-.0736.6414l.02.4247a14.9453,14.9453,0,0,1-.2047,1.72l.9229,1.7278a15.82,15.82,0,0,1,1.1188-2.3733,8.2666,8.2666,0,0,0,.7488-1.06,3.5825,3.5825,0,0,0,.483-1.2677A1.099,1.099,0,0,0,190.75,354.0054Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#cf9e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.2108,357.1136l-3.0644,5.6671-2.3537,1.4527a4.1658,4.1658,0,0,1-.4458.224,3.1393,3.1393,0,0,1-2.8684-.1579c-.7732-.4548-1.6034-.9456-1.6034-.9456l-.2811-.1253-.1589-.0672c-.007-.0057-.0229-.004-.0418.0012a1.4888,1.4888,0,0,0-.302.1352,2.8679,2.8679,0,0,1-.7269.3608,3.2831,3.2831,0,0,0-.87-.1373,2.5891,2.5891,0,0,0-1.97.7535,3.19,3.19,0,0,0-.6623,2.3776,28.2393,28.2393,0,0,0,.7811,5.6239c.8148,4.1712.1943,6.8251.6884,7.3292,1.939,1.9788,8.8231-.4655,8.4657-2.2182A24.2656,24.2656,0,0,1,181.4,370.17a2.9351,2.9351,0,0,1,.8746-1.6583c.023-.0221.0425-.04.0579-.0531,1.0091-.8712,3.1736-2.4493,3.8542-2.9807a3.1618,3.1618,0,0,0,.9636-1.2525l2.4735-5.9942C189.94,357.4207,187.6267,356.2271,187.2108,357.1136Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#2684ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.8305,355.758a6.2738,6.2738,0,0,0-3.05.22c-4.1664,1.3316-3.263,5.8072.4279,7.6018a1.6113,1.6113,0,0,0,2.0684-.5786c.14-.2246.2735-.4579.3982-.6722a5.03,5.03,0,0,0,.85-3.5079c-.004-.0246-.01-.05-.014-.0743.1392-.238.4081-.296.4961-.421A1.9465,1.9465,0,0,0,177.8305,355.758Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#171f40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.2513,360.7055c.3815.3239.52.7872.31,1.0349s-.69.1861-1.0715-.1378-.52-.7871-.31-1.0349S177.87,360.3817,178.2513,360.7055Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#cf9e76"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "b0d1b001-22bf-4306-a093-d21c5ab6a373",
    "data-name": "Layer 10"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "257.902 261.268 255.902 260.113 255.902 258.113 257.902 259.268 257.902 261.268",
    style: {
      fill: "#d92f15"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.902 263.577 259.902 262.423 259.902 260.423 261.902 261.577 261.902 263.577",
    style: {
      fill: "#ffcd1c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.902 265.887 263.902 264.732 263.902 262.732 265.902 263.887 265.902 265.887",
    style: {
      fill: "#ffcd1c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.902 264.268 255.902 263.113 255.902 261.113 257.902 262.268 257.902 264.268",
    style: {
      fill: "#008252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.902 266.577 259.902 265.423 259.902 263.423 261.902 264.577 261.902 266.577",
    style: {
      fill: "#ffcd1c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.902 268.887 263.902 267.732 263.902 265.732 265.902 266.887 265.902 268.887",
    style: {
      fill: "#ffcd1c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.902 278.081 255.902 276.926 255.902 274.926 257.902 276.081 257.902 278.081",
    style: {
      fill: "#d92f15"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.902 280.39 259.902 279.235 259.902 277.235 261.902 278.39 261.902 280.39",
    style: {
      fill: "#ffcd1c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.902 282.699 263.902 281.545 263.902 279.545 265.902 280.699 265.902 282.699",
    style: {
      fill: "#ffcd1c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.902 281.081 255.902 279.926 255.902 277.926 257.902 279.081 257.902 281.081",
    style: {
      fill: "#008252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.902 283.39 259.902 282.235 259.902 280.235 261.902 281.39 261.902 283.39",
    style: {
      fill: "#ffcd1c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.902 285.699 263.902 284.545 263.902 282.545 265.902 283.699 265.902 285.699",
    style: {
      fill: "#ffcd1c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.902 295.081 255.902 293.926 255.902 291.926 257.902 293.081 257.902 295.081",
    style: {
      fill: "#d92f15"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.902 297.39 259.902 296.235 259.902 294.235 261.902 295.39 261.902 297.39",
    style: {
      fill: "#ffcd1c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.902 299.699 263.902 298.545 263.902 296.545 265.902 297.699 265.902 299.699",
    style: {
      fill: "#ffcd1c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.902 298.081 255.902 296.926 255.902 294.926 257.902 296.081 257.902 298.081",
    style: {
      fill: "#008252"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.902 300.39 259.902 299.235 259.902 297.235 261.902 298.39 261.902 300.39",
    style: {
      fill: "#ffcd1c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.902 302.699 263.902 301.545 263.902 299.545 265.902 300.699 265.902 302.699",
    style: {
      fill: "#ffcd1c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "ea0c9a8f-d918-4287-91fc-179de4f82f74",
    "data-name": "Layer 11"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.46,
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.9,185.4385q-1.6618.27-3.3237.5414l-3.961,6.2488q.6889,1.2681,1.38,2.5364a28.1674,28.1674,0,0,0-1.6651,5.0011q-1.6665,1.65-3.3288,3.2993l0,5.6028q1.6662-.2711,3.3355-.5446a8.3258,8.3258,0,0,0,1.675,3.072q-.691,2.0583-1.3781,4.1192l3.96,1.6731q1.6659-1.6517,3.3326-3.3047a13.3,13.3,0,0,0,4.0417-.6658q.6876,1.2673,1.3789,2.5318l5.6006-3.2356q.6935-2.0682,1.3825-4.1314a35.7,35.7,0,0,0,4.0379-4.006c1.107-.1775,2.215-.3622,3.3232-.541l3.9621-6.2491q-.6912-1.267-1.38-2.5362a28.51,28.51,0,0,0,1.6655-5.0006q1.6634-1.6515,3.3262-3.3v-5.6007q-1.6671.2714-3.3359.5441a8.3,8.3,0,0,0-1.674-3.0723q.6906-2.0605,1.3774-4.1181l-3.9619-1.6733q-1.6637,1.6514-3.3309,3.302a13.4114,13.4114,0,0,0-4.0411.6667q-.688-1.2645-1.3783-2.5317L354.3193,177.3q-.6921,2.0679-1.3819,4.1336A35.7483,35.7483,0,0,0,348.9,185.4385Zm1.1417,6.3733c3.9162-6.1785,10.2653-9.8441,14.181-8.1879s3.9174,8.004.0012,14.1821c-3.9161,6.1761-10.266,9.8423-14.1822,8.1876S346.1266,197.986,350.0421,191.8118Z",
    transform: "translate(-3.0981 -15)",
    style: {
      fill: "#deebff"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderautomation);
export default __webpack_public_path__ + "static/media/orderautomation.53c11de668942c79c65ea088488e0de2.svg";
export { ForwardRef as ReactComponent };